module.exports = __webpack_public_path__ + "static/media/homepage3.49f5d563.svg";